import {Dispatch, AnyAction} from "redux";
import {MenuDto} from "../../services/Client";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "../actions/GeneralActions";

export class Helpers {

    private static getSomethingInternal<ResourceDtoType, ExecParam = any>(
        dispatch: Dispatch<any>,
        state: any,
        baseLinks: MenuDto | undefined,
        clientMethodName: string,
        mutexName: string,
        work: (value: ResourceDtoType) => void,
        loadingMessage: string,
        errorMessage: string,
        checkForData?: string | undefined,
        execParam?: ExecParam,
        passive?: boolean
    ) {
        if (state[mutexName] || (checkForData && state[checkForData]))
            return;
        if (!passive) {
            dispatch(GeneralActions.SetLoadingMutex(mutexName, true));
            dispatch(GeneralActions.AddLoadingMessage(loadingMessage));
        }
        state.client[clientMethodName](baseLinks).execute(execParam)
            .then((value: ResourceDtoType) => {
                if (!passive)
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingMessage));
                work(value);
                if (!passive)
                    dispatch(GeneralActions.SetLoadingMutex(mutexName, false));
            })
            .catch((reason: any) => {
                if (!passive)
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingMessage));
                renderErrorToast({message: errorMessage, details: reason, timestamp: Date.now()});
                if (!passive)
                    dispatch(GeneralActions.SetLoadingMutex(mutexName, false));
            });
    }

    public static getSomething<ResourceDtoType, ExecParam = any>(
        dispatch: Dispatch<any>,
        {general}: any,
        clientMethodName: string,
        mutexName: string,
        successAction: (value: ResourceDtoType) => AnyAction,
        loadingMessage: string,
        errorMessage: string,
        checkForData: string | undefined,
        execParam?: ExecParam,
        passive?: boolean
    ) {

        let links = general.baseLinks;
        if (general.client[clientMethodName](links).canExecute())
            this.getSomethingInternal(
                dispatch,
                general,
                general.baseLinks,
                clientMethodName,
                mutexName,
                (val: ResourceDtoType) => dispatch(successAction(val)),
                loadingMessage,
                errorMessage,
                checkForData,
                execParam,
                passive);
        else
            renderErrorToast({message: errorMessage, details: "BASELINK_NOT_FOUND", timestamp: Date.now()});
    }

    public static getSomethingWithLinks<ResourceDtoType, ExecParam = any>(
        dispatch: Dispatch<any>,
        {general}: any,
        links: MenuDto,
        clientMethodName: string,
        mutexName: string,
        successAction: (value: ResourceDtoType) => AnyAction,
        loadingMessage: string,
        errorMessage: string,
        checkForData: string | undefined,
        execParam?: ExecParam,
        passive?: boolean
    ) {
        if (general.client[clientMethodName](links).canExecute())
            this.getSomethingInternal(
                dispatch,
                general,
                links,
                clientMethodName,
                mutexName,
                (val: ResourceDtoType) => dispatch(successAction(val)),
                loadingMessage,
                errorMessage,
                checkForData,
                execParam,
                passive);
        else
            renderErrorToast({message: errorMessage, details: "BASELINK_NOT_FOUND", timestamp: Date.now()});
    }

    public static mapToFlatArray<ArrayElementType>(dispatch: Dispatch<any>, list: any, successAction: (data: ArrayElementType[]) => AnyAction, errorMessage: string): AnyAction {
        if (list.elements)
            return successAction(list.elements);
        renderErrorToast({message: errorMessage, details: "NO_ELEMENTS", timestamp: Date.now()});
        // TODO needs to be refactored
        // right now it returns a dummy action due to high workload of refactoring/testing
        return {type: ""};
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/Helpers.tsx